import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Mail, Check, Sparkles } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const EmailCapture = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // null | 'loading' | 'success' | 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !email.includes('@')) return;
    setStatus('loading');
    try {
      await axios.post(`${API}/waitlist`, { email: email.trim() });
      setStatus('success');
      setEmail('');
    } catch {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="bg-[#FF6B4A] py-12" data-testid="email-capture">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <div className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center mx-auto mb-4">
            <Check className="w-6 h-6 text-white" />
          </div>
          <p className="text-white font-semibold text-lg">You're in!</p>
          <p className="text-white/70 text-sm mt-1">Check your inbox for weekly skin tips and insights.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#FF6B4A] py-12" data-testid="email-capture">
      <div className="max-w-2xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center gap-2 mb-3">
          <Sparkles className="w-5 h-5 text-[#4ADE80]" />
          <p className="text-white/80 text-sm font-medium uppercase tracking-wider">Free Weekly Tips</p>
        </div>
        <h3 className="text-white font-heading text-2xl sm:text-3xl font-bold mb-2">Get Skin Tips in Your Inbox</h3>
        <p className="text-white/60 text-sm mb-6">Science-backed tips, food-skin insights, and supplement guides. Unsubscribe anytime.</p>
        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto">
          <div className="relative flex-1 w-full">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#8C7A76]" />
            <Input
              type="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setStatus(null); }}
              placeholder="your@email.com"
              className="pl-10 h-12 bg-white border-0 rounded-full w-full text-sm"
              data-testid="email-capture-input"
            />
          </div>
          <Button
            type="submit"
            disabled={status === 'loading' || !email.includes('@')}
            className="bg-[#A388EE] hover:bg-[#8f6fe0] text-white rounded-full h-12 px-6 text-sm font-semibold w-full sm:w-auto"
            data-testid="email-capture-submit"
          >
            {status === 'loading' ? 'Joining...' : 'Get Free Tips'}
          </Button>
        </form>
        {status === 'error' && <p className="text-[#A388EE] text-xs mt-2">Something went wrong. Try again.</p>}
        <p className="text-white/40 text-xs mt-4">Join 1,200+ people getting weekly skin insights</p>
      </div>
    </div>
  );
};

export default EmailCapture;
